import { VISUAL_GAME_NOTE_IMPORTANCE_VALUES } from '@drama/contracts/visual-game'

const NOTE_IMPORTANCE_VALUE_SET = new Set(VISUAL_GAME_NOTE_IMPORTANCE_VALUES)

export { VISUAL_GAME_NOTE_IMPORTANCE_VALUES }

export function isValidNoteImportance(value) {
  return value === undefined
    || value === null
    || value === ''
    || NOTE_IMPORTANCE_VALUE_SET.has(value)
}

export function assertValidNoteImportances(entries, sectionId) {
  for (const [index, entry] of entries.entries()) {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)) continue
    if (isValidNoteImportance(entry.importance)) continue
    throw new Error(
      `compilePack: ${sectionId}[${index}].importance must be empty or one of ${VISUAL_GAME_NOTE_IMPORTANCE_VALUES.join(', ')}; received ${JSON.stringify(entry.importance)}`,
    )
  }
}
